var _defs, _rect, _rect2, _circle, _rect3, _rect4, _circle2, _circle3, _rect5, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaveUpIkonGangtid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    "data-name": "Lager 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 768 766",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 284.69,
    y: 344.94,
    width: 230.73,
    height: 48.61,
    transform: "translate(30.81 769.3) rotate(-90)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 303,
    y: 191,
    width: 191.78,
    height: 49.52,
    transform: "translate(797.78 431.52) rotate(-180)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 399.28,
    cy: 426.58,
    r: 157.42
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 272.84,
    y: 413.93,
    width: 299.97,
    height: 12.34,
    transform: "translate(-173.22 422.03) rotate(-45)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 370.37,
    y: 270.12,
    width: 12.34,
    height: 299.97,
    transform: "translate(-186.77 389.3) rotate(-45)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 399.28,
    cy: 426.58,
    r: 108.42
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 400.82,
    cy: 424.07,
    r: 16.59
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 395.81,
    y: 418.29,
    width: 87.97,
    height: 12.35
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "405.92 426.77 435.79 351.18 424.31 346.64 392.64 426.77 405.92 426.77"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveUpIkonGangtid);
export default __webpack_public_path__ + "static/media/SaveUp_Ikon-gangtid.a027c5bd7e3f7e5045dae1ed65426b5b.svg";
export { ForwardRef as ReactComponent };